/**
 * Ensures images injected by apps and other client-side integrations meet the
 * HTML accessibility requirement to include an alt attribute.
 *
 * Theme-rendered images already include alt text. For third-party images, use
 * an explicit label when one is available and otherwise mark the image as
 * decorative. Existing alt attributes are never changed.
 */
function addMissingAlt(image) {
  if (!(image instanceof HTMLImageElement) || image.hasAttribute('alt')) return;

  const labelledLink = image.closest('a[aria-label]');
  const label = image.getAttribute('aria-label') || image.title || labelledLink?.getAttribute('aria-label') || '';

  image.alt = label.trim();
}

function addMissingAlts(root) {
  if (root instanceof HTMLImageElement) addMissingAlt(root);
  if (root instanceof Element || root instanceof Document) {
    root.querySelectorAll('img:not([alt])').forEach(addMissingAlt);
  }
}

addMissingAlts(document);

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach((node) => addMissingAlts(node));
  }
}).observe(document.documentElement, { childList: true, subtree: true });
